import { Directus } from '@directus/sdk';
import { API_FOOTER_SECTION_FIELDS, API_GROWING_FAMILY_FIELDS, API_LIBRARY_WIDGET_FIELDS, API_NEWSLETTER_FIELDS, API_PARTNER_SECTION_FIELDS } from './fields';
import Website from './models/Website';
export default class WebsiteAPI {
    static getInstance(basePath) {
        if (this.instance)
            return this.instance;
        if (!basePath) {
            basePath = process.env.CMS_URL;
        }
        const instance = new WebsiteAPI();
        instance.api = new Directus(basePath);
        return (this.instance = instance);
    }
    async getWebsiteCollection(lang) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('website').readOne(1, {
            fields: [
                ...API_GROWING_FAMILY_FIELDS,
                ...API_LIBRARY_WIDGET_FIELDS,
                ...API_NEWSLETTER_FIELDS,
                ...API_PARTNER_SECTION_FIELDS,
                ...API_FOOTER_SECTION_FIELDS
            ],
            deep: {
                growing_family_section: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                library_widget: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                newsletter_section: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                },
                partner_section: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                    partners: {
                        partner_id: {
                            translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
                        }
                    }
                },
                footer_section: {
                    translations: { _filter: { languages_code: { lang: { _eq: lang } } } },
                    footer_menu: {
                        menus_id: {
                            translations: { _filter: { languages_id: { lang: { _eq: lang } } } }
                        }
                    }
                }
            }
        }));
        return Website.fromApi(response);
    }
}
